export enum LineTemplateType {
  Service = 'service',
  FileAndUrl = 'file-url',
}

export enum DashboardPeriod {
  last24h = '24h',
  last1w = '1w',
  last1m = '1M',
}

export interface UserInfoFromDL {
  upn: string;
  assetID: string;
  email: string;
}

export interface UserCampaignPreparationUuid {
  campaignPreparationUuid: string;
}
